module.exports = __webpack_public_path__ + "img/vetoshkina.a5072f60.jpg";